import { Autocomplete, Box, Divider, Grid, ListItemIcon, ListItemText, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import style from "../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss";
import globalStyles from "../../../../assets/styles/global.module.scss";
import React, { useCallback, useContext, useRef, useState } from 'react'
import FileUpload from '../../../utility/fileUpload/fileUpload';
import { UserContext, UserContextPayload } from '../../../../context/userContext';
import axios from 'axios';
import { filterAutocompleteOptionsWithException, getFileTypeImgIcon, getWhatsappMediaAllowedFileTypes, getWhatsappMediaSizeLimit } from '../../../../utils/constants';
import { primaryColor } from '../../../../utils/colors';
import { WorkflowContext, WorkflowContextPayload } from '../../../../context/workflowContext';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../context/flowBuilderContext';
import { customVariableDataInterface } from '../../../../models/axiosModel';
import autoCompleteStyles from './../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss';
import IconsColor from '../../../utility/iconsColor';
import styles from './../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import validator from 'validator';
import { debounce, DebouncedFunc } from 'lodash';
import { isCurrentViewVersionPublished } from '../../../dashboard/flowBuilder/utilityFunctions';
import { useFlowBuilderStore } from '../../../../store/flowBuilderStore';
import { getCurrentVariableType, renderFieldsBasedonFieldType } from '../../../dashboard/flowBuilder/flowBuilderConstants';
import { getLocationCoordinateWarning, isValidLatitudeValue, isValidLongitudeValue } from '../../../dashboard/templatelibrary/constant';

interface DynamicHeaderVariablesProps {
    actionData: any,
    stepAction: any, 
    messageTemplateDetail: any, 
    onBlurOfFallBackOfBtnVar: DebouncedFunc<(value: string, index: number) => void>,
    renderFieldOptions:  (props: React.HTMLAttributes<HTMLLIElement>, option: any) => React.ReactNode, 
    getFieldTypeValue: (whatsapp_template_dynamic_variable_id: number) => any,
    getFieldValue: (whatsapp_template_dynamic_variable_id: number) => any,
    getFallbackValue: (whatsapp_template_dynamic_variable_id: number) => any, 
    uploadFileHandler: (e: any, whatsapp_template_dynamic_variable_id: number) => Promise<void>,
    removeFileHandler: () => Promise<void>,
    files: any,
    isFileUploaded: boolean,
} 

const DynamicHeaderVariables: React.FC<DynamicHeaderVariablesProps> = (props) => {
    const { actionData, stepAction, messageTemplateDetail, onBlurOfFallBackOfBtnVar, renderFieldOptions, getFieldValue, getFallbackValue, uploadFileHandler, removeFileHandler, files, isFileUploaded, getFieldTypeValue } = props;
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload
    const customVariableList = useFlowBuilderStore((state) => state.customVariableList)
    const metaDataVariableList = useFlowBuilderStore((state) => state.metaDataVariableList)
    const { variableTypes, onChangeCurrentActiveNodeConfig, inValidVariableId, setInValidVariableId, nodes, currentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload

    const handleValidLocationCoordinate = (value: string, variableKey: string, variableId: number) => {
        const normalizedKey = variableKey?.toLowerCase() ?? "";
        const isValid = normalizedKey === "{{latitude}}"
            ? isValidLatitudeValue(value)
            : normalizedKey === "{{longitude}}"
                ? isValidLongitudeValue(value)
                : true;

        setInValidVariableId((prev) => {
            if (isValid) {
                return prev.filter((id) => id !== variableId);
            }
            return prev.includes(variableId) ? prev : [...prev, variableId];
        });
    }

    const renderHeaderVariableValue = (variable: any, ind: number) => {
        if (messageTemplateDetail) {
            const headerType = messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_type_name.toLowerCase();
            const variableKey = variable?.whatsapp_template_dynamic_variable_key ?? "";
            const isLocationCoordinateField = headerType === "location"
                && ["{{latitude}}", "{{longitude}}"].includes(variableKey.toLowerCase());
            const isInvalidLocationCoordinate = isLocationCoordinateField
                && inValidVariableId.includes(variable?.whatsapp_template_dynamic_variable_id);
            const locationCoordinateWarning = isInvalidLocationCoordinate
                ? getLocationCoordinateWarning(variableKey)
                : "";

            switch (headerType) {
                case "text":
                case "location":
                    return (
                        <Box className={globalStyles.fullwidth}>
                            <TextField
                                value={getFallbackValue(variable?.whatsapp_template_dynamic_variable_id)}
                                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                placeholder='Enter Value'
                                onChange={(e) => {
                                    if (isLocationCoordinateField) {
                                        handleValidLocationCoordinate(
                                            e.target.value,
                                            variableKey,
                                            variable.whatsapp_template_dynamic_variable_id
                                        );
                                    }
                                    onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
                                        { flag_fallback: true, fallback_value: e.target.value, whatsapp_template_dynamic_variable_id: variable.whatsapp_template_dynamic_variable_id },
                                        {
                                            updateType: "editExistingStepAction"
                                        }
                                    )
                                }}
                                className={style.whatsappCampaignTextField}
                                sx={{
                                    width: "100%",
                                    minWidth: "200px",
                                    backgroundColor: "white",
                                    border: isInvalidLocationCoordinate ? "1px solid red" : undefined,
                                    height: "fit-content",
                                }}
                            />
                            {locationCoordinateWarning && (
                                <span className={styles.invalidValueWarning}>
                                    {locationCoordinateWarning}
                                </span>
                            )}
                        </Box>
                    )   
            }

            if (headerType === "image" || headerType === "video" || headerType === "document") {
                return (
                    <>
                        <Grid container gap={"12px"} flexWrap={"nowrap"} alignItems="flex-start">
                            <Grid item xs={10.5} sx={{ alignSelf: "flex-start" }}>
                                <Box className={globalStyles.fullwidth}>
                                    <TextField
                                        disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                        value={getFallbackValue(variable?.whatsapp_template_dynamic_variable_id)}
                                        placeholder='Enter URL'
                                        onChange={(e) => {
                                            onBlurOfFallBackOfBtnVar(e.target.value, variable.whatsapp_template_dynamic_variable_id)
                                            onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
                                                { flag_fallback: true, fallback_value: e.target.value?.trim()?.length > 0 ? e.target.value : null, whatsapp_template_dynamic_variable_id: variable.whatsapp_template_dynamic_variable_id },
                                                {
                                                    updateType: "editExistingStepAction"
                                                }
                                            )
                                        }}
                                        className={style.whatsappCampaignTextField}
                                        sx={{ width: "100%", minWidth: "200px", backgroundColor: "white", border: inValidVariableId.includes(variable.whatsapp_template_dynamic_variable_id) ? "1px solid red" : "", height: "fit-content" }}
                                    />
                                    {inValidVariableId.includes(variable.whatsapp_template_dynamic_variable_id) && <span className={styles.invalidValueWarning}>Please Enter Valid URL</span>}
                                </Box>
                            </Grid>
                            <Grid item sx={{ alignSelf: "flex-start" }}>
                                <FileUpload
                                    uploadedFileDetails={files}
                                    multipleFileAllow={true}
                                    fileSizeAllowed={getWhatsappMediaSizeLimit(headerType)}
                                    fileTypeAllowed={getWhatsappMediaAllowedFileTypes(headerType)?.allowedType}
                                    fileNumberAllowed={2}
                                    uploadFileHandler={(e) => uploadFileHandler(e, variable?.whatsapp_template_dynamic_variable_id)}
                                    removeFileHandler={removeFileHandler}
                                    isDeleteFileIconVisible={isFileUploaded}
                                    flagShowJustIcon={true}
                                    isDisabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                    flagWhatsapp={true}
                                />
                            </Grid>
                        </Grid>
                    </>
                );
            }
        }
    }

    return (
        <Grid container direction={"column"} gap={"10px"} marginBlock={"10px"}>
            <Grid item>
                <Typography className={style.assignValuesTitle}>Assign Values to Template Header Variables</Typography>
            </Grid>

            {messageTemplateDetail &&
                <Grid item sx={{ width: "100%" }}>
                    <TableContainer sx={{ boxSizing: "border-box", maxWidth: "100%", width: "100%", overflow: "auto" }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={style.tableHeadingFontStyle}></TableCell>
                                    <TableCell className={style.tableHeadingFontStyle}>Field Type</TableCell>
                                    <TableCell className={style.tableHeadingFontStyle}>Field</TableCell>
                                    <TableCell className={style.tableHeadingFontStyle}>Static Value</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data.map((variable: any, ind: any) => {
                                    return (
                                        <TableRow key={ind} className={style.tableRow}>
                                            <TableCell className={style.tableSubHeadingFontStyle}>{variable.whatsapp_template_dynamic_variable_key}</TableCell>
                                            <TableCell className={style.tableSubHeadingFontStyle} sx={{ minWidth: "150px" }}>
                                                <Autocomplete
                                                    disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                    className={`${autoCompleteStyles.contactFilterDropdownsInPopup}`}
                                                    disableClearable
                                                    options={variableTypes}
                                                    getOptionLabel={(option) => option.variable_label || ''}
                                                    value={getFieldTypeValue(variable?.whatsapp_template_dynamic_variable_id)}
                                                    onChange={(_, value: any) => {
                                                        onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
                                                            { flag_variable_type: true, variable_type: value, whatsapp_template_dynamic_variable_id: variable.whatsapp_template_dynamic_variable_id },
                                                            {
                                                                updateType: "editExistingStepAction"
                                                            }
                                                        )
                                                    }}
                                                    renderInput={(params) => <TextField {...params} placeholder="Select Field Type" />}
                                                    sx={{ '&:hover': { backgroundColor: "white !important" }, backgroundColor: "white !important" }}
                                                />
                                            </TableCell>
                                            <TableCell className={style.tableSubHeadingFontStyle} sx={{ minWidth: "220px" }}>
                                                {renderFieldsBasedonFieldType(getCurrentVariableType(variable, stepAction), customVariableList, metaDataVariableList, currentActiveStaticWorkflow, renderFieldOptions)?.flagShowVariableMappingField ?
                                                    <Autocomplete
                                                        className={`${autoCompleteStyles.contactFilterDropdownsInPopup}`}
                                                        options={renderFieldsBasedonFieldType(getCurrentVariableType(variable, stepAction), customVariableList, metaDataVariableList, currentActiveStaticWorkflow, renderFieldOptions)?.fieldOptions || []}
                                                        getOptionLabel={(option: any) => option[renderFieldsBasedonFieldType(getCurrentVariableType(variable, stepAction), customVariableList, metaDataVariableList, currentActiveStaticWorkflow, renderFieldOptions)?.fieldOptionKey] || ''}
                                                        filterOptions={(options, state) => filterAutocompleteOptionsWithException(options, state, renderFieldsBasedonFieldType(getCurrentVariableType(variable, stepAction), customVariableList, metaDataVariableList, currentActiveStaticWorkflow, renderFieldOptions)?.fieldOptionKey 
                                                            === "chatbot_custom_variable_name" 
                                                            ? "chatbot_custom_variable_name" 
                                                            : "metadata_type_name", "chatbot_custom_variable_configuration_id")}
                                                        value={getFieldValue(variable?.whatsapp_template_dynamic_variable_id) || null}
                                                        sx={{ '&:hover': { backgroundColor: "white !important" }, backgroundColor: "white !important" }}
                                                        onChange={(_: React.SyntheticEvent, value: customVariableDataInterface | null) => {
                                                            // onChangeOfTag(value)
                                                            onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
                                                                { ...value, whatsapp_template_dynamic_variable_id: variable.whatsapp_template_dynamic_variable_id },
                                                                {
                                                                    updateType: "editExistingStepAction"
                                                                }
                                                            )
                                                        }}
                                                        // onBlur={(e) => handleValidWebsite(e.target.value, index)}
                                                        ListboxProps={renderFieldsBasedonFieldType(getCurrentVariableType(variable, stepAction), customVariableList, metaDataVariableList, currentActiveStaticWorkflow, renderFieldOptions)?.listBoxProps}
                                                        renderOption={renderFieldsBasedonFieldType(getCurrentVariableType(variable, stepAction), customVariableList, metaDataVariableList, currentActiveStaticWorkflow, renderFieldOptions)?.renderOption}
                                                        disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                        renderInput={params => {
                                                            const { InputProps, ...restParams } = params;
                                                            const { startAdornment, ...restInputProps } = InputProps;
                                                            return (
                                                                <TextField
                                                                    {...restParams}
                                                                    placeholder='Select Field'
                                                                    InputProps={{
                                                                        ...restInputProps,
                                                                        startAdornment: (
                                                                            <div style={{
                                                                                maxHeight: "90px",
                                                                                overflowY: 'auto',
                                                                            }}
                                                                            >
                                                                                {startAdornment}
                                                                            </div>
                                                                        ),
                                                                    }}
                                                                />
                                                            );
                                                        }}
                                                    />
                                                    :
                                                    "Not Applicable"

                                                }
                                            </TableCell>
                                            <TableCell className={style.tableSubHeadingFontStyle}>
                                                {renderFieldsBasedonFieldType(getCurrentVariableType(variable, stepAction), customVariableList, metaDataVariableList, currentActiveStaticWorkflow, renderFieldOptions)?.flagShowStaticValueField ?
                                                    renderHeaderVariableValue(variable, ind)
                                                    :
                                                    "Not Applicable"
                                                }
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            }
        </Grid>
    )
}

export default DynamicHeaderVariables
